import * as React from 'react';
import {FunctionComponent, useState} from 'react';
import {CalendarEvent} from '../../../../../Models/CalendarEvent';
import {FullCrew} from '../../../../../Models/Crew';
import {CrewRsvpCalendar} from './Components/CrewRsvpCalendar';

interface OwnProps {
    referenceDate: Date;
    crews: FullCrew[];
    calendarEvents: CalendarEvent[];
    onCalendarEventClick: (calendarEvent: CalendarEvent) => void;
}

const getFirstDayOfMonth = (date: Date) => {
    return new Date(date.getFullYear(), date.getMonth(), 1);
};

const getLastDayOfMonth = (date: Date) => {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
};

export const RsvpCalendar: FunctionComponent<OwnProps> = ({
    crews,
    calendarEvents,
    referenceDate,
    onCalendarEventClick,
}) => {
    const [activeCrewId, setActiveCrewId] = useState<number>(crews[0].id);
    const filteredCalendarEvents = calendarEvents
        .filter((calendarEvent) => {
            return (
                calendarEvent.startAt >= getFirstDayOfMonth(referenceDate) &&
                calendarEvent.startAt <= getLastDayOfMonth(referenceDate)
            );
        })
        .sort((a, b) => {
            if (a.startAt < b.startAt) {
                return -1;
            }
            if (a.startAt > b.startAt) {
                return 1;
            }
            return 0;
        });

    return (
        <>
            {crews.length > 1 && (
                <div className="row">
                    <div className="col-12 d-flex justify-content-end">
                        <div className="mb-2 me-2">
                            <select
                                className="form-select"
                                value={activeCrewId}
                                onChange={(e) => setActiveCrewId(parseInt(e.target.value, 10))}
                            >
                                {crews.map((crew) => (
                                    <option key={crew.id} value={crew.id}>
                                        {crew.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
            )}
            <div className="row">
                <div className="col-12">
                    <CrewRsvpCalendar
                        crew={crews.find((crew) => crew.id === activeCrewId)!}
                        calendarEvents={filteredCalendarEvents}
                        onCalendarEventClick={onCalendarEventClick}
                    />
                </div>
            </div>
        </>
    );
};
